import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import rootReducer from './reducers';
import rootSaga from './sagas';

// Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['Layout', 'auth', 'user', 'awards', 'pvs'], // only persist these reducers
};

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Create the store with middleware
const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredActionPaths: ['register', 'rehydrate'],
        ignoredPaths: ['register', 'rehydrate'],
      },
      thunk: false,
    });

    // Add saga middleware
    middlewares.push(sagaMiddleware);

    // Add logger in development
    if (process.env.NODE_ENV === 'development') {
      middlewares.push(logger);
    }

    return middlewares;
  },
  devTools: process.env.NODE_ENV !== 'production',
});

// Run saga middleware
sagaMiddleware.run(rootSaga);

// Create persistor
const persistor = persistStore(store);

export { store, persistor };
